<template>
  <div id="Footer">
    <b-container fluid class="footerMain">
      <b-row>
        <b-col>
          <p>Major League Baseball trademarks and copyrights are used with permission of MLB Advanced Media, LP All rights reserved <a href="https://www.mlb.com/official-information/terms-of-use" target="_blank">MLB.com Terms of Use</a> <span class="lineDivider">|</span> <a href="https://www.mlb.com/official-information/privacy-policy"  target="_blank">MLB.com Privacy Policy</a> <span class="lineDivider">|</span> <a target="_blank" href="http://www.raysbaseball.com/policiesandprocedures">Policies and Procedures</a> <img src="@/assets/icons/rayscom-blue-footer.svg" /></p>
        </b-col>
      </b-row>
      <b-row class="copyright">© 2021 MLB Advanced Media, LP. All rights reserved.</b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style lang="scss" scoped>
  #Footer {
    width: 100%;
    padding: 8px 0;
    .footerMain {
      text-align: center;
      padding: 0 7%;
      p {
        font-family: 'UniversLTStd';
        font-size: 12px;
        display: flex;
        justify-content: center;
        color: $dark-blue;
        @media only screen and (max-width: $sm) {
          flex-direction: column;
        }
        a {
          padding: 0 5px;
          text-decoration: underline;
          color: $dark-blue;
        }
        img {
          margin-left: 10px;
          margin-top: 3px;
          width: 100px;
          @media only screen and (max-width: $sm) {
            margin: 10px auto 0 auto;
            position: relative;
            left: 11px;
          }
        }
        .lineDivider {
          @media only screen and (max-width: $sm) {
            display: none;
          }
        }
      }
    }
    .copyright{
      margin-top: 15px;
      font-family: 'UniversLTStd';
      font-size: 12px;
      display: flex;
      justify-content: center;
      color: #002962;
    }
  }
</style>